import { useKept } from "../kept";

// A row of chips that narrows a list to one kind (byj-1wv.45): All, then each
// kind with its count — a kind with none is shown dimmed, so the whole set is
// always in view. Which is picked is kept per browser, under `filter:<id>`.

export type Chip = { value: string; label: string; count: number };

/**
 * The filter in force: the one picked, unless its kind has none left — a
 * filter kept from an earlier visit then lists nothing at all — when it is
 * All (byj-1wv.45).
 */
export function inForce(value: string, chips: Chip[]): string {
  const c = chips.find((x) => x.value === value);
  return c && c.count > 0 ? value : "all";
}

export function useFilter(id: string): [string, (v: string) => void] {
  return useKept(`filter:${id}`, "all", (s) => s, (v) => v);
}

export function FilterChips({ label, chips, value, onChange }: { label: string; chips: Chip[]; value: string; onChange: (v: string) => void }) {
  return (
    <div className="filter-chips row wrap" role="group" aria-label={label}>
      {chips.map((c) => (
        <button
          key={c.value}
          type="button"
          // not `empty`: that class is the page's empty state, a 3rem margin
          // that dropped an empty chip below its row
          className={`chip filter-chip${value === c.value ? " picked" : ""}${c.count === 0 ? " filter-chip-empty" : ""}`}
          aria-pressed={value === c.value}
          disabled={c.count === 0 && c.value !== "all"}
          onClick={() => onChange(c.value)}
        >
          {c.label} <span className="filter-count">{c.count}</span>
        </button>
      ))}
    </div>
  );
}
